import * as z from 'zod';

export const RemittanceType = z.enum(['SCHEDULED_SCHEDULED', 'SCHEDULED_ACTUAL', 'ACTUAL_ACTUAL']);
export type RemittanceType = z.infer<typeof RemittanceType>;
